import AxiosFactory from '@/services/axiosFactory';
import type { AxiosResponse } from 'axios';
import type { Member } from '@/models/member';
import type { Customer, DeliveryDates } from '@/models/customer';
import type { Type } from '@/models/shared';

export default class InfoService {
    private client = AxiosFactory.create({
        baseURL: '/api/v1/'
    });

    public async GetCustomerInfo(email: string, debitoNumber: string): Promise<AxiosResponse<Customer>> {
        return (await this.client).get(`customer?email=${encodeURIComponent(email)}&debitorNumber=${debitoNumber}`);
    }

    public async GetDeliveryDates(sku: string, packingType: string, salesUnit: string, debitorNumber: string, postalCode: string): Promise<AxiosResponse<DeliveryDates>> {
        return (await this.client).get(`delivery?sku=${sku}&packingType=${packingType}&salesUnit=${salesUnit}&debitorNumber=${debitorNumber}&postalCode=${postalCode}`);
    }

    public async GetMemberInfo(): Promise<AxiosResponse<Member>> {
        return (await this.client).get('member');
    }
    public async GetSiloTypes(): Promise<AxiosResponse<Type[]>> {
        return (await this.client).get('siloType');
    }
    public async GetvehicleTypes(): Promise<AxiosResponse<Type[]>> {
        return (await this.client).get('vehicleType');
    }
    public async GetOilTankTypes(): Promise<AxiosResponse<Type[]>> {
        return (await this.client).get('oilTankType');
    }
    public async GetOilTankVehicleTypes(): Promise<AxiosResponse<Type[]>> {
        return (await this.client).get('oilTankVehicleType');
    }
    public async Validate(): Promise<AxiosResponse<any>> {
        return (await this.client).get('/member/validate');
    }
}
